var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPossiblePayments02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 54,
    viewBox: "0 0 84 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1007_42520)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.01695,
    y: 0.991561,
    width: 82.0519,
    height: 51.9104,
    rx: 4.18632,
    fill: "white",
    stroke: "#E7EAEE",
    strokeWidth: 1.67453
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1007_42520",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 54
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.01695,
    y: 0.991561,
    width: 82.0519,
    height: 51.9104,
    rx: 4.18632,
    fill: "white",
    stroke: "#D2D2D6",
    strokeWidth: 1.67453
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1007_42520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3828 53.7392H81.1598C82.6642 53.7392 83.907 52.4963 83.907 50.9919V31.761C78.4779 35.2278 57.9388 47.1326 24.3828 53.7392Z",
    fill: "#F58220"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1097 21.8774H10.2266V31.9466H13.0944C14.6193 31.9466 15.7205 31.5869 16.687 30.7842C17.8356 29.8337 18.5149 28.4009 18.5149 26.919C18.5153 23.9477 16.2949 21.8774 13.1097 21.8774ZM15.4041 29.4416C14.7869 29.9989 13.9855 30.2419 12.7164 30.2419H12.1894V23.5836H12.7164C13.9855 23.5836 14.7555 23.8105 15.4041 24.3979C16.0834 25.0026 16.4919 25.94 16.4919 26.9043C16.4919 27.8712 16.0834 28.8371 15.4041 29.4416Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.386 21.8774H19.4219V31.9466H21.386V21.8774Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1798 25.7416C25.0012 25.3056 24.6551 25.0179 24.6551 24.474C24.6551 23.8395 25.2717 23.3579 26.1182 23.3579C26.7068 23.3579 27.1902 23.5996 27.702 24.1732L28.7296 22.8276C27.8851 22.0888 26.8747 21.7112 25.7708 21.7112C23.9892 21.7112 22.6302 22.9484 22.6302 24.5964C22.6302 25.9836 23.2629 26.6938 25.1075 27.3575C25.8766 27.6287 26.2679 27.8093 26.4654 27.9309C26.8578 28.1871 27.0543 28.5501 27.0543 28.9727C27.0543 29.7886 26.4057 30.3929 25.5294 30.3929C24.5926 30.3929 23.838 29.9245 23.3859 29.0501L22.1172 30.272C23.0221 31.6002 24.1088 32.189 25.6034 32.189C27.6444 32.189 29.0762 30.832 29.0762 28.8828C29.0759 27.2829 28.4141 26.5586 26.1798 25.7416Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7031 26.919C29.7031 29.8786 32.0274 32.1736 35.018 32.1736C35.8636 32.1736 36.5877 32.0073 37.4806 31.5869V29.2749C36.6953 30.0608 35.9999 30.3777 35.1095 30.3777C33.1314 30.3777 31.7276 28.9434 31.7276 26.9043C31.7276 24.9712 33.176 23.446 35.0184 23.446C35.9552 23.446 36.6642 23.7803 37.4809 24.579V22.2679C36.6187 21.8305 35.91 21.6494 35.0647 21.6494C32.0885 21.6499 29.7031 23.9915 29.7031 26.919Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0497 28.6409L50.3645 21.8774H48.2188L52.4922 32.2051H53.5489L57.8989 21.8774H55.7698L53.0497 28.6409Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7891 31.9466H64.3592V30.2422H60.7516V27.5243H64.2262V25.8186H60.7516V23.5836H64.3592V21.8774H58.7891V31.9466Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.132 24.8501C72.132 22.9649 70.8335 21.8774 68.5684 21.8774H65.6562V31.9466H67.618V27.9017H67.8742L70.5926 31.9468H73.008L69.8383 27.7046C71.3174 27.4038 72.132 26.3919 72.132 24.8501ZM68.1918 26.5132H67.6181V23.4635H68.2228C69.4461 23.4635 70.1111 23.976 70.1111 24.9559C70.1111 25.9683 69.4462 26.5132 68.1918 26.5132Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4738 32.3037C46.4321 32.3037 48.8303 29.9055 48.8303 26.9471C48.8303 23.9888 46.4321 21.5906 43.4738 21.5906C40.5154 21.5906 38.1172 23.9888 38.1172 26.9471C38.1172 29.9055 40.5154 32.3037 43.4738 32.3037Z",
    fill: "url(#paint0_linear_1007_42520)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M43.4738 32.3037C46.4321 32.3037 48.8303 29.9055 48.8303 26.9471C48.8303 23.9888 46.4321 21.5906 43.4738 21.5906C40.5154 21.5906 38.1172 23.9888 38.1172 26.9471C38.1172 29.9055 40.5154 32.3037 43.4738 32.3037Z",
    fill: "url(#paint1_linear_1007_42520)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3928 22.2557C73.3928 22.0792 73.2712 21.9827 73.0576 21.9827H72.7734V22.8677H72.9846V22.5243L73.2323 22.8677H73.4901L73.199 22.5028C73.3241 22.4693 73.3928 22.3786 73.3928 22.2557ZM73.0205 22.3767H72.9848V22.1453H73.0227C73.1271 22.1453 73.1816 22.1829 73.1816 22.2591C73.1816 22.3371 73.1264 22.3767 73.0205 22.3767Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.099 21.6523C72.6692 21.6523 72.3281 21.9952 72.3281 22.4238C72.3281 22.8523 72.6731 23.1956 73.099 23.1956C73.5176 23.1956 73.8606 22.8484 73.8606 22.4238C73.8606 22.001 73.5174 21.6523 73.099 21.6523ZM73.0956 23.0576C72.7574 23.0576 72.4807 22.7762 72.4807 22.4249C72.4807 22.0726 72.7538 21.7913 73.0956 21.7913C73.4322 21.7913 73.7065 22.079 73.7065 22.4249C73.7065 22.7731 73.4325 23.0576 73.0956 23.0576Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1007_42520",
    x1: 46.2156,
    y1: 31.24,
    x2: 42.5067,
    y2: 25.4331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2502,
    stopColor: "#F79A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5331,
    stopColor: "#F78E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6196,
    stopColor: "#F68721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    stopColor: "#F48220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1007_42520",
    x1: 45.6297,
    y1: 31.1611,
    x2: 40.2091,
    y2: 20.5662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68721",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3587,
    stopColor: "#E27027",
    stopOpacity: 0.2704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#D4612C",
    stopOpacity: 0.5299
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#D15D2D",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1007_42520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.7264,
    height: 53.5849,
    fill: "white",
    transform: "translate(0.179688 0.154297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPossiblePayments02);
export default __webpack_public_path__ + "static/media/Possible-payments 02.d8ddbd4874cc0a37acd7ba535db82a94.svg";
export { ForwardRef as ReactComponent };